<template>
  <div class="vars__options auth__container d-flex justify-center">
    <div
      class="auth__wrapper d-flex flex-row justify-center align-center"
      :class="wrapperStyles ? wrapperStyles : ''"
    >
      <div
        class="d-flex flex-column justify-center form-container align-center"
        :class="[authFormStyles ? authFormStyles : '']"
      >
        <div v-if="appLogo" v-html="appLogo"></div>
        <img
          v-if="!appLogo"
          :class="[logoStyles !== '' ? logoStyles : 'mb-10']"
          src="../assets/LogoIT.png"
          height="62" width="62"
        />

        <h3 class="appTitle">{{ appTitle }}</h3>
<!--        <h3 class="appTitle">Государственная информационная система Московской области ”Цифровой офис”</h3>-->

        <slot :class="[slotStyles ? slotStyles : '']"></slot>
      </div>
    </div>

  </div>
</template>

<script>
import "../assets/styles/main.css";
import "../assets/styles/register.css";

export default {
  components: {

  },
  props: [
    "logoStyles",
    "wrapperStyles",
    "authFormStyles",
    "slotStyles",
    "appLogo",
    "appTitle",
    "sudirState"
  ],
  data() {
    return {
      slides: [],
      activeSlide: null,
    };
  },
};
</script>
